import { useEffect, useState } from 'react'

/**
 * Delays a value until it stops changing.
 *
 * Search-as-you-type otherwise fires a provider request per keystroke; 250ms
 * is long enough to coalesce a burst of typing and short enough that the
 * dropdown still feels immediate.
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debounced
}
